import { render, staticRenderFns } from "./SettingsWidget.vue?vue&type=template&id=556b8b0e&scoped=true"
import script from "./SettingsWidget.vue?vue&type=script&lang=js"
export * from "./SettingsWidget.vue?vue&type=script&lang=js"
import style0 from "./SettingsWidget.vue?vue&type=style&index=0&id=556b8b0e&prod&lang=scss"
import style1 from "./SettingsWidget.vue?vue&type=style&index=1&id=556b8b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b8b0e",
  null
  
)

export default component.exports